import { IProgram, ISpeakerExtended } from "../../interfaces/models/IEvent";

function speakerNeedsEnrichment(speaker: ISpeakerExtended): boolean {
  if (!speaker.personId) {
    return false;
  }

  const needsPhotoOrLogo = !speaker.photo || !speaker.firmLogo;
  const needsTitleFix =
    !speaker.title || speaker.title.trim().toLowerCase() === "other";

  return !speaker.name || needsPhotoOrLogo || needsTitleFix;
}

export function programsNeedEnrichment(programs: IProgram[] | undefined): boolean {
  if (!programs?.length) {
    return false;
  }

  return programs.some((program) => {
    const speakers = [
      ...(program.speakers ?? []),
      ...(program.postEventSpeakers ?? []),
    ];
    return speakers.some(speakerNeedsEnrichment);
  });
}
